import { render, staticRenderFns } from "./addprosend.vue?vue&type=template&id=600b5880"
import script from "./addprosend.vue?vue&type=script&lang=js"
export * from "./addprosend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports